// OperationStageSo.js (SO Only)

import React, { useState, useEffect } from 'react';
import { connect ,useSelector} from 'react-redux';
import {
  Paper, Table, TableBody, TableCell, TableContainer,
  TableRow, TableHead, Button, TextField, Typography,
  IconButton, Select, MenuItem, CircularProgress, Box,
  Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText,Modal,  FormControl,
  InputLabel, 
  Stepper, 
  Step, 
  StepLabel, 
  StepContent, 
  Chip, 
  Tooltip
} from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { FaEdit, FaDownload } from "react-icons/fa";
import moment from 'moment';
import HttpService from '../../services/httpService';
import { setLoading, setSnackInfo } from '../../redux/actions/appAction';
import { buttonShowEmailForApprovePaymentRequestView, TdsChangesAccess ,vendorManagerObjectId, ROLENAME, constantDepartmentId} from "../../utils/index";
import LinearProgress from '@material-ui/core/LinearProgress';
import { FaEye } from "react-icons/fa";
import { CSVLink } from "react-csv";
import ClearIcon from '@material-ui/icons/Clear';
import * as XLSX from 'xlsx';

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 850,
  },
  textField: {
    width: 100
  },
  loaderContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '300px',
    flexDirection: 'column'
  },
  noDataContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: '40px',
    fontSize: '18px',
    color: '#666'
  }
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#ccc",
    color: theme.palette.common.black,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);
const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 3,
};

const OperationStageSo = (props) => {
  const classes = useStyles();
 
  const {userDetails} =  useSelector((state)=> state.user) ;
  const email = localStorage.getItem("EMAIL_ID");
  const [paymentRequests, setPaymentRequests] = useState([]);
  // const [paymentRequestStatus,setPaymentRequestStatus] = useState("Raised");
  const [paymentRequestStatus,setPaymentRequestStatus] = useState("Request for You");
  const [loading, setLoadingState] = useState(true);
  // const [paymentHistory,setPaymentHistory] = useState([]);
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [rejectReason, setRejectReason] = useState('');
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const [searchTimeout, setSearchTimeout] = useState(null);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [downloadingExcel, setDownloadingExcel] = useState(false);
  const isBelongToFinance = userDetails?.departmentId === constantDepartmentId.FinanceDepartment;
  const isAdmin = !!userDetails?.roles?.find((role) => role?.name === ROLENAME.Admin);
  // GST payment approval is a finance/admin only screen
  const canViewGstPaymentApproval = isBelongToFinance || isAdmin;

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(200); // default limit
   const [pagination, setPagination] = useState({
    totalRecords: 0,
    totalAvailable: 0,
    totalPages: 0,
    hasNextPage: false,
    hasPrevPage: false
  });
  const [totalPages, setTotalPages] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  


  const [totalValues, setTotalValues] = useState({
    total: 0,
    paymentDoneTotal: 0,
    raisedAmountTotal: 0,
    amountDueTotal: 0,
    approvingInputTotal: 0
  });
  const [editingTds, setEditingTds] = useState({
    id: null,
    value: 0,
    isEditing: false
  });
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    action: '',
    payment: null,
    title: '',
    baseMessage : '',
    extraMessage : ''
    // message: ''
  });

  useEffect(() => {
     if (!isSearching) {
        getData();
    }
  }, [paymentRequestStatus, page, limit]);

  const tdsOptions = [
    { value: 0, label: '0%' },
    { value: 0.1, label: '0.1%' },
    { value: 1, label: '1%' },
    { value: 2, label: '2%' },
    { value: 5, label: '5%' },
    { value: 10, label: '10%' },
    { value: 20, label: '20%' }
  ];

  const handleTdsChange = async (e, paymentId) => {
    const tdsPercentage = parseFloat(e.target.value);
    setLoadingState(true);
    
    try {
      let response = await HttpService.updateServiceOrderTds(
        paymentId, 
        { tdsPercentage }
      );
      if (response.data.success) {
        await getData();
        props.setSnackInfo(`TDS updated to ${tdsPercentage}%`, "success");
      }
    } catch (error) {
      props.setSnackInfo(
        error.response?.data?.error || "Update failed", 
        "error"
      );
    } finally {
      setLoadingState(false);
    }
  };
//  get all data ..for so rolewise approval flow wise.
  const getData = async (searchQuery = '') => {
    setLoadingState(true);
    try {
      const result = await HttpService.getSopaymentreqRoleWise(paymentRequestStatus,page, limit,searchQuery);
      if(result?.status === 200){
         const responseData = result?.data;
        setPaymentRequests(result?.data?.data || []);
        setIsSearching(responseData?.isSearching || false);
        setPagination({
          totalRecords: responseData?.totalRecords || 0,
          totalAvailable: responseData?.totalAvailable || 0,
          totalPages: responseData?.totalPages || 0,
          hasNextPage: responseData?.hasNextPage || false,
          hasPrevPage: responseData?.hasPrevPage || false
        });
        setTotalPages(Math.ceil(responseData?.totalAvailable / limit));
      }
      
      let paymentRequests = result?.data?.data | [];
      let total = 0, paymentDoneTotal = 0, raisedAmountTotal = 0, amountDueTotal = 0, approvingInputTotal = 0;
      
      if (paymentRequests.length > 0) {
        total = paymentRequests.reduce((acc, crr) => ({ total: +acc.total + +crr.total })).total;
        paymentDoneTotal = paymentRequests.reduce((acc, crr) => ({ paymentDone: +acc.paymentDone + +crr.paymentDone })).paymentDone;
        raisedAmountTotal = paymentRequests.reduce((acc, crr) => ({ raisedAmount: +acc.raisedAmount + +crr.raisedAmount })).raisedAmount;
        amountDueTotal = +total - (+paymentDoneTotal + +raisedAmountTotal);
        approvingInputTotal = paymentRequests.reduce((acc, paymentRequest) => acc + +paymentRequest.paymentRequests[0].amount, 0);
        
        setTotalValues({ 
          total, 
          paymentDoneTotal, 
          raisedAmountTotal, 
          amountDueTotal, 
          approvingInputTotal 
        });
      }
    } catch (error) {
      console.error(error);
      props.setSnackInfo('Error fetching data', "error");
    } finally {
      setLoadingState(false);
    }
  };
//   showing all the paymnet history of  a so
// 4. Add search handler function
const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    
    // Clear existing timeout
    if (searchTimeout) {
        clearTimeout(searchTimeout);
    }
    
    // If search is empty, get regular data 
    if (!value.trim()) {
        setIsSearching(false);
        getData('');
        return;
    }
    
    // Set new timeout for search (debounce)
    const timeout = setTimeout(() => {
        setIsSearching(true);
        getData(value.trim());
    }, 500);
    
    setSearchTimeout(timeout);
};
// 5. Clear search function
const handleClearSearch = () => {
    setSearchTerm('');
    setIsSearching(false);
    if (searchTimeout) {
        clearTimeout(searchTimeout);
    }
    getData('');
};

  const showConfirmDialog = (action, payment) => {
    const isApprove = action === "Approved";
    setConfirmDialog({
      open: true,
      action,
      payment,
      title: `Confirm ${isApprove ? 'Approval' : 'Rejection'}`,
      baseMessage: `Are you sure you want to ${isApprove ? 'approve' : 'reject'} this payment request of ₹${payment.amount}?`,
      extraMessage: !isApprove
      ? "This will send a mail to the person who raised the request with Remarks."
      : "",
    });
  };

  const handleConfirmAction = async () => {
    const { action, payment } = confirmDialog;
    if (action === "Rejected" && (!rejectReason.trim() || rejectReason.trim().length <= 10)) {
      props.setSnackInfo("Provide a valid reason for rejection (more than 10 characters)", "warning");
      return;
    }    
    setConfirmDialog({ open: false, action: '', payment: null, title: '', baseMessage: '' , extraMessage : ''});
    await editPayementRequest(action, payment,rejectReason);
  };

  const handleCancelAction = () => {
    setConfirmDialog({ open: false, action: '', payment: null, title: '', baseMessage: '' , extraMessage: '' });
  };
  //  checking whether 90 days crossed or not 
  const getGreaterThan180DaysFlag = (customerDesignSignOffDate, payment) => {
  if (!customerDesignSignOffDate) return false;

  const designDate = new Date(customerDesignSignOffDate);
  const today = new Date();

  // Handle MongoDB $date object format:
  const rawDate = payment?.raisedAt || payment?.createdAt ;
  const resolvedDate = rawDate?.$date ? rawDate.$date : rawDate;
  const raiseDate = new Date(resolvedDate); 
  // console.log("raiseDate", raiseDate)
  // console.log("designDate",designDate)

  const diffTime = raiseDate - designDate; 
  // console.log("difference in ms", diffTime);

  const diffDays = diffTime / (1000 * 60 * 60 * 24); // convert to days
  // console.log("difference in days", diffDays);

  return diffDays >= 180;
};
  // customerDesignSignOffDate date used to check 90 days crossed or not
//  reject or approve payment request
  const editPayementRequest = async (status, payment,rejectReason = "") => {
    setLoadingState(true);
    try {
      const parentSO = paymentRequests.find(so =>
        so.paymentRequests.some(pr => pr._id === payment._id)
      );
  
      // const totalAmount = parentSO?.total ?? 0;
      // const raisedPercentage = ((+payment.amount / +totalAmount) * 100).toFixed(2);
      const totalAmount = +parentSO?.total ?? 0;
      const paymentDone = +parentSO?.paymentDone ?? 0;
      const statusApprovedAmount = +parentSO?.statusApprovedAmount ?? 0;
      const currentRaisedAmount = +payment.amount ?? 0;

      const totalProgress = paymentDone + statusApprovedAmount + currentRaisedAmount;
      const raisedPercentage = ((totalProgress / totalAmount) * 100).toFixed(2);


      const leadStage = parentSO?.projectId?.leadId?.currentStage || 'null';
      // const greaterThan180Days = getGreaterThan180DaysFlag(parentSO?.projectId?.leadId?.customerDesignSignOffDate) || false;
      const greaterThan180Days = getGreaterThan180DaysFlag(parentSO?.projectId?.leadId?.customerDesignSignOffDate,payment) || false;
      const soType = payment?.soType || 'NA';
  
     
      const requestBody = {
        status,
        amount: payment.amount,
        raisedPercentage,
        leadStage,
        greaterThan180Days,
        soType,
      };
      if (status === "Rejected") {
        requestBody.rejectReason = rejectReason;
        requestBody.rejectedBy = userDetails?._id;
        requestBody.raisedBy =payment?.raisedBy || payment?.raisedBy?._id || vendorManagerObjectId?.deepakMahadev;
      }
      
      const response = await HttpService.approvereditServiceOrderPaymentStatusRoleWise(
        payment?._id, 
        requestBody
      );
      if (response.status === 200) {
        await getData();
        props.setSnackInfo(`Payment ${status}`, "success");
      }
    } catch (error) {
      console.error(error);
      props.setSnackInfo(error?.response?.data ?? "Something went Wrong", "error");
    } finally {
      setLoadingState(false);
    }
  };
  const changeRaisedAmount = (e, i, j) => {
    const so = paymentRequests[i];
    const total = +so.total || 0;
    const paymentDone = +so.paymentDone || 0;
    const statusApprovedAmount = +so.statusApprovedAmount || 0;
  
    const dueAmount = total - paymentDone - statusApprovedAmount;
    const enteredAmount = +e.target.value;
  
    if (enteredAmount <= dueAmount) {
      let payments = [...paymentRequests];
      payments[i].paymentRequests[j].amount = enteredAmount;
      setPaymentRequests(payments);
    } else {
      alert(`Entered amount exceeds due amount. Remaining SO Amount is ₹${dueAmount.toFixed(2)}`);
    }
  };
  

  const handleMultipleDownloads = (attachments) => {
    if (!Array.isArray(attachments)) {
      console.error("Attachments is not an array:", attachments);
      return;
    }
    
    if (attachments.length === 0) {
      console.warn("No attachments to download");
      return;
    }
    
    if (attachments.length > 1) {
      downloadSequentially(attachments);
    } else {
      const link = document.createElement('a');
      link.href = attachments[0];
      const filename = attachments[0].split('/').pop() || 'attachment';
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const downloadSequentially = (urls) => {
    let currentIndex = 0;
    
    const downloadNext = () => {
      if (currentIndex >= urls.length) {
        return; 
      }
      
      const url = urls[currentIndex];
      const link = document.createElement('a');
      link.href = url;
      const filename = url.split('/').pop() || `attachment-${currentIndex + 1}`;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      currentIndex++;
      setTimeout(downloadNext, 500);
    };
    
    downloadNext();
  };

  // Show loader while data is loading
  if (loading) {
    return (
      <Box className={classes.loaderContainer}>
        <CircularProgress size={60} />
        <Typography variant="h6" style={{ marginTop: '16px', color: '#666' }}>
          Loading Service Orders...
        </Typography>
      </Box>
    );
  }
//  function to set / get data for a perticular reject approve data for a SO
  const GetApprovalRejectLogs = async (orderId) => {
    if (!orderId) {
      props.setSnackInfo('Order ID not found', 'warning');
      return;
    }
    handleOpen(); // open the modal or drawer
    await showPaymentHistory(orderId);
  };
  
  // 3. Data fetcher showing 
  const showPaymentHistory = async (id) => {
   setLoadingModal(true)
    try {
      const result = await HttpService.allPaymentHistoryOfASO(id);
    
      if (result.status === 200) {
        setPaymentHistory(result?.data?.data?.paymentRequests); 
      }
    } catch (err) {
      console.error(err);
      props.setSnackInfo('Error fetching data', "error");
      setLoadingModal(false)
    } finally {
      props.setLoading(false);
      setLoadingModal(false);
    }
  };
    // Pagination handlers
  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleLimitChange = (e) => {
    const newLimit = Number(e.target.value);
    setLimit(newLimit);
    setPage(1); 
  };

  const handlePaymentStatusChange = (e) => {
    setPaymentRequestStatus(e.target.value);
    setPage(1); 
  };
  // 3. Create the download function
const downloadAllDataAsExcel = async () => {
    setDownloadingExcel(true);
    try {
        // Fetch all data for the current payment request status
        const result = await HttpService.getSopaymentreqRoleWiseAll(paymentRequestStatus);
        
        if (result?.status === 200) {
            const allData = result?.data?.data || [];
            
            if (allData?.length === 0) {
                props.setSnackInfo('No data available for download', "warning");
                return;
            }
            
            // Process data for Excel export
            const excelData = allData.map((data, index) => {
                const total = parseFloat(data?.total || 0);
                const paymentDone = parseFloat(data?.paymentDone || 0);
                const raisedAmount = parseFloat(data?.raisedAmount || 0);
                const amountDue = total - (paymentDone + raisedAmount);
                
                // Calculate TDS
                const tdsPercentage = data?.paymentRequests?.[0]?.tdsPercentage || 0;
                const currentPaymentAmount = parseFloat(data?.paymentRequests?.[0]?.amount || 0);
                const tdsAmount = (currentPaymentAmount * tdsPercentage) / 100;
                const amountToBeTransferred = currentPaymentAmount - tdsAmount;
                
                const excelObj = {
                    "Sl No": index + 1,
                    "Order ID": data?.orderId,
                    "Client & Code": `${data?.projectId?.clientName ?? 'OPEN'} ${data?.projectId?.code ?? 'PROCUREMENT'}`,
                    "Vendor Name": data?.vendorName || data?.vendorId?.name || data?.materials?.[0]?.vendorId?.name || '',
                    "Created At": moment(data?.createdAt).format('DD-MM-YYYY'),
                    "TDS (%)": tdsPercentage,
                    "Status": data?.status,
                    "SO Type": data?.paymentRequests?.[0]?.soType || 'NA',
                    "SO Total": total,
                    "Already Approved": paymentDone,
                    "TDS Amount": tdsAmount,
                    "Amount to be Transferred": amountToBeTransferred,
                    "Raised Amount": raisedAmount,
                    "Payment (%)": data?.paymentRequests?.[0]?.amount && total !== 0
                        ? ((Number(data.paymentRequests[0].amount) / total) * 100).toFixed(2) + '%'
                        : '',
                    "Amount Due": amountDue,
                    "Current Approver": data?.paymentRequests?.[0]?.currentApprover || '',
                    "Remarks": data?.paymentRequests?.[0]?.remarks || ''
                };
                
                return excelObj;
            });
            
            // Create and download Excel file
            const worksheet = XLSX.utils.json_to_sheet(excelData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Payment Requests");
            
            // Generate filename with current date and payment type
            const filename = `Payment_Requests_${paymentRequestStatus.replace(/\s+/g, '_')}_${moment().format('DD-MM-YYYY')}.xlsx`;
            
            // Download the file
            XLSX.writeFile(workbook, filename);
            
            props.setSnackInfo(`Successfully downloaded ${allData.length} records`, "success");
            
        } else {
            props.setSnackInfo('Failed to fetch data for download', "error");
        }
    } catch (error) {
        console.error('Error downloading Excel:', error);
        props.setSnackInfo('Error downloading Excel file', "error");
    } finally {
        setDownloadingExcel(false);
    }
};


  
  return (
    <div>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
        flexWrap="wrap"
      >
        <Typography variant="h6" gutterBottom style={{ fontWeight: 'bold' }}>
          Service Order Payment Approval Table
        </Typography>
            <Box style={{ display: 'flex', gap: 10 }}>
          {canViewGstPaymentApproval && (
            <Button
              variant="contained"
              onClick={() => window.open('/so-payment-request-approval/gst', '_blank', 'noopener,noreferrer')}
              style={{ textDecoration: 'none', backgroundColor: '#2E7D32', color: '#fff' }}
              component="span"
            >
              GST Payment Approval
            </Button>
          )}
          <Button variant="contained"
           onClick={downloadAllDataAsExcel}
          color="primary"
          style={{ textDecoration: 'none' }}
          disabled={downloadingExcel}
          component="span">
             {downloadingExcel ? 'Downloading...' : ' Download Excel'}
          </Button>
        </Box>
            
      </Box>
      <Box
        display="flex"
        alignItems="center"
        gap={5}
        mb={2}
        flexWrap="wrap"
      >
        <FormControl style={{ minWidth: 200 }} size="small">
          <InputLabel id="so-payment-status-label">SO Payment Status</InputLabel>
          <Select
            labelId="so-payment-status-label"
            id="so-payment-status-select"
            value={paymentRequestStatus}
            label="SO Payment Status"
            onChange={(e) => setPaymentRequestStatus(e.target.value)}
          >
            <MenuItem value="Request for You">Request for You</MenuItem>
            <MenuItem value="Raised">Raised</MenuItem>
            <MenuItem value="Approved">Approved</MenuItem>
            <MenuItem value="Rejected">Rejected</MenuItem>
          </Select>
        </FormControl>
        <Box style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <TextField 
                id="outlined-basic" 
                label="Search By SO Order-Id" 
                variant="standard" 
                style={{ minWidth: 200, marginLeft: 20 }} 
                size="small"
                value={searchTerm}
                onChange={handleSearchChange}
                placeholder="e.g., SO_1353_5165"
                InputProps={{
                    endAdornment: (
                        <>
                            {loading && (
                                <CircularProgress size={20} style={{ marginRight: 8 }} />
                            )}
                            {searchTerm && (
                                <IconButton 
                                    size="small" 
                                    onClick={handleClearSearch}
                                    style={{ padding: 4 }}
                                >
                                    <ClearIcon fontSize="small" />
                                </IconButton>
                            )}
                        </>
                    )
                }}
            />
        </Box>
      </Box>
      <Box mb={2}>
        <Typography variant="body2" color="textSecondary">
          Showing {((page - 1) * limit) + 1} to {Math.min(page * limit, pagination.totalAvailable)} of {pagination.totalAvailable} entries
        </Typography>
      </Box>
      {/* Pagination Controls */}
      {!isSearching && pagination.totalPages > 1 && (
        <Box 
          display="flex" 
          justifyContent="space-between" 
          alignItems="center" 
          mt={3}
          mb={2}
          flexWrap="wrap"
          gap={2}
        >
          {/* Page Info */}
          <Typography variant="body2" color="textSecondary">
            Page {page} of {pagination.totalPages}
          </Typography>

          {/* Page Number Buttons */}
          <Box display="flex" gap={1}>
            {(() => {
              const pages = [];
              const startPage = Math.max(1, page - 2);
              const endPage = Math.min(pagination.totalPages, page + 2);
              
              if (startPage > 1) {
                pages.push(
                  <Button
                    key={1}
                    variant={page === 1 ? "contained" : "outlined"}
                    size="small"
                    onClick={() => handlePageChange(1)}
                    disabled={loading}
                  >
                    1
                  </Button>
                );
                if (startPage > 2) {
                  pages.push(<Typography key="ellipsis1" variant="body2">...</Typography>);
                }
              }
              
              for (let i = startPage; i <= endPage; i++) {
                pages.push(
                  <Button
                    key={i}
                    variant={page === i ? "contained" : "outlined"}
                    size="small"
                    onClick={() => handlePageChange(i)}
                    disabled={loading}
                  >
                    {i}
                  </Button>
                );
              }
              
              if (endPage < pagination.totalPages) {
                if (endPage < pagination.totalPages - 1) {
                  pages.push(<Typography key="ellipsis2" variant="body2">...</Typography>);
                }
                pages.push(
                  <Button
                    key={pagination.totalPages}
                    variant={page === pagination.totalPages ? "contained" : "outlined"}
                    size="small"
                    onClick={() => handlePageChange(pagination.totalPages)}
                    disabled={loading}
                  >
                    {pagination.totalPages}
                  </Button>
                );
              }
              return pages;
            })()}
          </Box>
        </Box>
      )}
      { paymentRequests && paymentRequests?.length > 0 ? (
        <TableContainer component={Paper}>
        <Table className={classes.table} size="small" aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Sl No</StyledTableCell>
              <StyledTableCell>Order Id</StyledTableCell>
              <StyledTableCell>Client & Code</StyledTableCell>
              <StyledTableCell>Vendor Name</StyledTableCell>
              {isBelongToFinance && (
                <StyledTableCell>Vendor PAN</StyledTableCell>
              )}
              {/* <StyledTableCell>Vendor Category</StyledTableCell> */}
              <StyledTableCell>Approval/Rejection Logs</StyledTableCell>
              <StyledTableCell>Created At</StyledTableCell>
              {isBelongToFinance && ( <StyledTableCell>TDS (%)</StyledTableCell>)}
              <StyledTableCell>Status</StyledTableCell>             
              <StyledTableCell>SO Type</StyledTableCell>  
              {
                (paymentRequestStatus === "Raised" || paymentRequestStatus === "Request for You") && (
                    <StyledTableCell>Attachments</StyledTableCell>
                )
              }   
              {
                (paymentRequestStatus === "Raised" || paymentRequestStatus === "Request for You") && (
                    <StyledTableCell>Remarks</StyledTableCell>
                )
              }         
              <StyledTableCell>SO Total</StyledTableCell>
              <StyledTableCell> {paymentRequestStatus === "Rejected" ? "Total Rejected"  : "Already Approved" }</StyledTableCell>
              <StyledTableCell>TDS Amount</StyledTableCell>
              <StyledTableCell>Amount to be Transfer</StyledTableCell>
              {
                (paymentRequestStatus === "Raised" || paymentRequestStatus === "Request for You") &&  (<StyledTableCell>Raised Amount</StyledTableCell> )
              }
              {
               ( paymentRequestStatus === "Raised" || paymentRequestStatus === "Request for You") &&  (<StyledTableCell>Payment (%)</StyledTableCell> )
              }
              {
                (paymentRequestStatus === "Raised" || paymentRequestStatus === "Request for You") &&  (<StyledTableCell>Amount Due</StyledTableCell> )
              }
              {
                (paymentRequestStatus === "Raised" || paymentRequestStatus === "Request for You") &&  (<StyledTableCell></StyledTableCell> )
              }
            </TableRow>
          </TableHead>
          <TableBody>
            {paymentRequests?.map((data, i) => (
              <StyledTableRow key={i + 1}>
                <StyledTableCell>{i + 1}</StyledTableCell>
                <StyledTableCell>{data?.orderId}</StyledTableCell>
                <StyledTableCell>{`${data?.projectId?.clientName ?? 'OPEN'} ${data?.projectId?.code ?? 'PROCUREMENT'}`}</StyledTableCell>
                <StyledTableCell>{data?.vendorName || data?.vendorId?.name || data?.materials[0]?.vendorId?.name}</StyledTableCell>
                {
                  isBelongToFinance && (
                    <StyledTableCell style={{ color: '#1976d2', fontWeight: '500' }}>{data?.panNumber || data?.vendorId?.panNumber || data?.materials[0]?.vendorId?.panNumber || "-"} </StyledTableCell>
                  )
                }
                {/* <StyledTableCell>NA</StyledTableCell> */}
               
                <StyledTableCell>
                  {/* <Box style={{ display: 'flex', gap: 2 }}> */}
                  <Box style={{ display: 'flex', margin:"Auto" ,alignItems:"center"}}>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={() => GetApprovalRejectLogs(data?.orderId)}
                      style={{
                        borderRadius: '6px',
                        minWidth: '70px',
                        height: '32px',
                        padding: 0,
                        backgroundColor: '#1976d2',
                        color:"primary"
                      }}
                    >
                      <FaEye style={{ fontSize: '20px', color: '#fff' }} />
                    </Button>
                  </Box>
                </StyledTableCell>

                <StyledTableCell>{moment(data?.createdAt).format('DD-MM-YYYY')}</StyledTableCell>
                {
                  isBelongToFinance && (
                    <StyledTableCell style={{ position: 'relative' }}>
                  {editingTds.id === data._id && editingTds.isEditing ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <Select
                        value={editingTds.value}
                        onChange={(e) => setEditingTds({...editingTds, value: e.target.value})}
                        variant="outlined"
                        size="small"
                        style={{ width: '150px' }}
                        autoFocus
                      >
                        {tdsOptions.map(option => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={async () => {
                          await handleTdsChange({ target: { value: editingTds.value } }, data._id);
                          setEditingTds({ id: null, value: 0, isEditing: false });
                        }}
                        style={{ marginLeft: '8px', textTransform: 'none' }}
                      >
                        Update
                      </Button>
                    </div>
                  ) : (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <Typography variant="body1">
                        {tdsOptions.find(opt => opt.value === (data?.tdsPercentage ?? 0))?.label || '0%'}
                      </Typography>
                      <IconButton 
                        onClick={() => setEditingTds({
                          id: data._id,
                          value: data?.tdsPercentage ?? 0,
                          isEditing: true
                        })}
                        size="small"
                      >
                        <FaEdit />
                      </IconButton>
                    </div>
                  )}
                </StyledTableCell>
                  )
                }
                <StyledTableCell>{data?.status}</StyledTableCell>
                <StyledTableCell>{data?.paymentRequests[0]?.soType || "NA"}</StyledTableCell>
                {
                     (paymentRequestStatus === "Raised" || paymentRequestStatus === "Request for You") && (
                <StyledTableCell style={{ textAlign: "center" }}>
                  {data?.paymentRequests?.some(req => req.status === "Raised" && req.attachment) ? (
                    data.paymentRequests.map((req, index) =>

                      req.status === "Raised" && req.attachment ? (
                        <div key={index}>
                          <div 
                            onClick={() => handleMultipleDownloads(req.attachment)} 
                            style={{ cursor: 'pointer' }}
                            title={`Download all ${Array.isArray(req.attachment) ? req.attachment.length : 0} attachments`}
                          >
                            <FaDownload size={20} color="green" />
                          </div>
                        </div>
                      ) : null
                    )
                  ) : (
                    <span>N/A</span>
                  )}
                </StyledTableCell>
                     )
                }
                {
                     (paymentRequestStatus === "Raised" || paymentRequestStatus === "Request for You") && (
                <StyledTableCell style={{ textAlign: "center" }}>
                  {data?.paymentRequests?.some(req => req.status === "Raised" && req.attachment && req.remarks) ? (
                    data.paymentRequests.map((req, index) =>
                      req.status === "Raised" && req.attachment && req.remarks ? (
                        <div key={index}>
                          <Tooltip title={req?.remarks}>
                         <span>{req.remarks.slice(0,10)}{req?.remarks?.length >25? "...":""}</span>
                        </Tooltip>
                        </div>
                      ) : null
                    )
                  ) : (
                    <span>N/A</span>
                  )}
                </StyledTableCell>
                     )
                }
                {/*  so total amount */}
                <StyledTableCell>{data?.total}</StyledTableCell>
                {/*  already paid amount */}
                 {
                  paymentRequests && (
                    <StyledTableCell>
                      <Box>
                        <Typography variant="body2" color="textPrimary">
                          ₹{paymentRequestStatus === "Rejected" ? data?.totalRejected : data?.paymentDone}
                        </Typography>
                        <LinearProgress
                          variant="determinate"
                          value={
                            paymentRequestStatus === "Rejected"
                              ? (data?.totalRejected / data?.total) * 100
                              : (data?.paymentDone / data?.total) * 100
                          }
                          style={{ height: 8, borderRadius: 4 }}
                        />
                        <Typography variant="caption" color="textSecondary">
                          {paymentRequestStatus === "Rejected"
                            ? ((data?.totalRejected / data?.total) * 100).toFixed(2)
                            : ((data?.paymentDone / data?.total) * 100).toFixed(2)}%
                        </Typography>
                      </Box>
                    </StyledTableCell>
                  )
                
                
                }
                   {/*  tds amount and percent */}
                <StyledTableCell>
                  {data?.total && data?.tdsPercentage
                    ? (+data.total * +data.tdsPercentage / 100).toFixed(2)
                    : '0.00'}
                </StyledTableCell>

                <StyledTableCell>
                  {data?.total && data?.tdsPercentage
                    ? (+data.total - (+data.total * +data.tdsPercentage / 100)).toFixed(2)
                    : data?.total}
                </StyledTableCell>

                {/*  total raised amoutn */}
               {
               ( paymentRequestStatus === "Raised"  || paymentRequestStatus === "Request for You") && ( 
                  <StyledTableCell>{+data?.raisedAmount}</StyledTableCell>
                )
               }
               {
               ( paymentRequestStatus === "Raised" || paymentRequestStatus === "Request for You") && ( <StyledTableCell>{(((data.paymentRequests[0].amount) / +data?.total) * 100).toFixed(2)}%</StyledTableCell> )
               }
                {
                  (paymentRequestStatus === "Raised"  || paymentRequestStatus === "Request for You") && (

                    <StyledTableCell>{(+data?.total - (+data?.paymentDone + +data?.statusApprovedAmount)).toFixed(2) || "-"} </StyledTableCell>
                  )
                }
                <TableRow>
                  {
                   ( paymentRequestStatus === "Raised" || paymentRequestStatus === "Request for You") && (<StyledTableCell>Amount</StyledTableCell>)
                  }
                  {
                   ( paymentRequestStatus === "Raised" || paymentRequestStatus === "Request for You") && (<StyledTableCell></StyledTableCell>)
                  }
                  
                    <StyledTableCell></StyledTableCell>
                  {/* )} */}
                </TableRow>
                {data?.paymentRequests?.map((request, j) => (
                  <StyledTableRow key={j}>
                    {
                     ( paymentRequestStatus === "Raised"  || paymentRequestStatus === "Request for You") && (
                      <StyledTableCell>
                      <StyledTableRow>
                        <StyledTableCell>
                          <TextField 
                            value={request?.amount} 
                            disabled = {!isBelongToFinance}
                            onChange={(e) => changeRaisedAmount(e, i, j)} 
                            variant="outlined" 
                            className={classes.textField} 
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          {`(${((+request?.amount / +data?.total) * 100).toFixed(2)}%)`}
                        </StyledTableCell>
                      </StyledTableRow>
                    </StyledTableCell>
                      )
                    }
                    {
                     ( paymentRequestStatus === "Raised"  || paymentRequestStatus === "Request for You") &&
                      request?.currentApprover &&
                      userDetails?.roles?.some(role => role?.name?.includes(request?.currentApprover)) && (
                        <StyledTableCell>
                          <div className="approve-reject-btn">
                            <button onClick={() => showConfirmDialog("Approved", request)} className="approve-btn">
                              Approve
                            </button>
                            <button onClick={() => showConfirmDialog("Rejected", request)} className="reject-btn">
                              Reject
                            </button>
                          </div>
                        </StyledTableCell>
                      )
                      }
                    {/* )} */}
                  </StyledTableRow>
                ))}
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      ) : (
        <div className={classes.noDataContainer}>No Payment Request Raised.</div>
      )}
      {/* Confirmation Dialog */}
        <Dialog
          open={confirmDialog.open}
          onClose={handleCancelAction}
          aria-labelledby="confirmation-dialog-title"
          aria-describedby="confirmation-dialog-description"
        >
          <DialogTitle id="confirmation-dialog-title">
            {confirmDialog.title}
          </DialogTitle>

          <DialogContent>
            <DialogContentText id="confirmation-dialog-description">
              {confirmDialog.baseMessage}
            </DialogContentText>
            <DialogContentText id="confirmation-dialog-description" color="error" fontWeight="bold">
              {confirmDialog.extraMessage}
            </DialogContentText>

            {/* Show input if rejecting */}
            {confirmDialog.action === "Rejected" && (
              <TextField
                autoFocus
                margin="dense"
                id="reject-reason"
                label="Reason for Rejection"
                type="text"
                fullWidth
                variant="standard"
                value={rejectReason}
                onChange={(e) => setRejectReason(e.target.value)}
                required
              />
            )}
          </DialogContent>

          <DialogActions>
            <Button onClick={handleCancelAction} color="default">
              Cancel
            </Button>
            <Button
              onClick={handleConfirmAction}
              color={confirmDialog.action === "Approved" ? "primary" : "secondary"}
              variant="contained"
              autoFocus
            >
              {confirmDialog.action === "Approved" ? "Approve" : "Reject"}
            </Button>
          </DialogActions>
        </Dialog>
      {/* Modal Code */}
      <Modal open={open} onClose={handleClose}>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '95%',
          maxWidth: 1200,
          maxHeight: '90vh',
          bgcolor: 'background.paper',
          border: '2px solid #000',
          boxShadow: 24,
          p: 4,
          overflow: 'auto'
        }}>
          <Typography variant="h6" component="h2">
            Approval / Reject Logs
          </Typography>

          <Typography sx={{ mt: 2 }}>
            Below are the approval or rejection logs for this payment:
          </Typography>
          {loadingModal ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 4 }}>
              <CircularProgress />
              <Typography sx={{ mt: 2 }}>Loading logs...</Typography>
            </Box>
          ) : (
            <>
              {paymentHistory?.map((item, index) => {
                              // Function to generate approval track steps
                              // generateApprovalTrack function
                              const generateApprovalTrack = (payment) => {
                               const steps = [];
                           // Helper function to determine who is the final approver
                                const getFinalApproverLabel = () => {
                                  // If both secondApprover and finalApprover exist, Operation Head is final
                                  if (payment.secondApprover && payment.finalApprover) {
                                    return 'Operation Head';
                                  }

                                  // If only finalApprover exists , Senior Operation Manager is final
                                  if (payment.finalApprover && !payment.secondApprover) {
                                    return 'Senior Operation Manager';
                                  }

                                  return 'Operation Head'; // Default
                                };

                  // 2.Define approval stages based on payment type
                  let approvalStages = payment?.paymentType === 'Capex'
                    ? [
                      { key: 'firstApprover', label: 'Growth Manager', dateKey: 'firstApprovalDate' },
                      { key: 'finalApprover', label: 'Operation Head', dateKey: 'finalApprovalDate' },
                    ]
                    : [
                      { key: 'firstApprover', label: 'Execution User', dateKey: 'firstApprovalDate' },
                      { key: 'secondApprover', label: 'Senior Operation Manager', dateKey: 'secondApprovalDate' },
                      { key: 'finalApprover', label: getFinalApproverLabel(), dateKey: 'finalApprovalDate' },
                    ];

                  //  If Senior Operation Manager approved directly to "Final" 
                  //  Senior Operation Manager is only evaluated once as the Final Approver.
                  if (payment?.paymentType !== 'Capex' && !payment.secondApprover && payment.finalApprover) {
                    approvalStages = [
                      { key: 'firstApprover', label: 'Execution User', dateKey: 'firstApprovalDate' },
                      { key: 'finalApprover', label: 'Senior Operation Manager', dateKey: 'finalApprovalDate' }
                    ];
                  }

                  // 3. Determine the "Raised By" role based on payment type and raisedBy presence
                  const getRaisedByRole = () => {
                    if (payment?.raisedBy?.name) {
                      return payment?.raisedBy.name;
                    }
                    return payment?.paymentType === 'Capex' ? 'Project Manager' : 'Vendor Manager';
                  };

                  if (payment?.status === 'Raised') {
                    // Always show "Raised By" step
                    steps.push({
                      label: 'Raised By',
                      role: getRaisedByRole(),
                      status: 'approved',
                      date: payment.raisedAt || payment?.createdAt,
                    });
                     // If there's a currentApprover, show steps till current approver

                    if (payment.currentApprover) {
                      let currentApproverFound = false;

                      for (const stage of approvalStages) {
                        if (payment[stage.key] === null) continue;
                       // If this is the current approver stage
                        if (stage.label === payment.currentApprover) {
                          steps.push({
                            label: stage.label,
                            role: payment[stage.key]?.name || stage.label,
                            status: 'pending',
                            date: payment[stage.dateKey] || null,
                          });
                          currentApproverFound = true;
                          break;
                        } else {
                          // Previous stages should be approved
                          steps.push({
                            label: stage.label,
                            role: payment[stage.key]?.name || stage.label,
                            status: 'approved',
                            date: payment[stage.dateKey] || payment?.createdAt,
                          });
                        }
                      }

                      if (!currentApproverFound) {
                        steps.push({
                          label: payment.currentApprover,
                          role: payment.currentApprover,
                          status: 'pending',
                          date: null,
                        });
                      }
                    } else {
                      const firstStage = approvalStages[0];
                      steps.push({
                        label: firstStage.label,
                        role: payment[firstStage.key]?.name || firstStage.label,
                        status: 'pending',
                        date: payment[firstStage.dateKey] || null,
                      });
                    }
                  }
                  else if (payment?.status === 'Rejected') {
                    // Always start with "Raised By" as approved
                    steps.push({
                      label: 'Raised By',
                      role: getRaisedByRole(),
                      status: 'approved',
                      date: payment.raisedAt || payment?.createdAt,
                    });
                    // Check if rejectedBy is present
                    if (payment.rejectedBy) {
                      // Find the current approver stage and mark previous stages as approved
                      let rejectorFound = false;

                      for (let i = 0; i < approvalStages.length; i++) {
                        const stage = approvalStages[i];
                        // Skip if this stage is null (jumped stage)
                        if (payment[stage.key] === null) continue;

                        if (payment.currentApprover && stage.label.includes(payment.currentApprover)) {
                          steps.push({
                            label: stage.label,
                            role: payment.rejectedBy?.name || stage.label,
                            status: 'rejected',
                            date: payment.rejectedAt,
                          });
                          rejectorFound = true;
                          break;
                        } else {
                          // Previous stages are approved
                          steps.push({
                            label: stage.label,
                            role: payment[stage.key]?.name || stage.label,
                            status: 'approved',
                            date: payment[stage.dateKey] || payment?.createdAt,
                          });
                        }
                      }

                      if (!rejectorFound) {
                        steps.push({
                          label: 'Rejected By',
                          role: payment.rejectedBy?.name || payment.currentApprover?.name || 'User',
                          status: 'rejected',
                          date: payment.rejectedAt,
                        });
                      }
                    } else {
                      for (let i = 0; i < Math.min(2, approvalStages.length); i++) {
                        const stage = approvalStages[i];
                        if (payment[stage.key] !== null) {
                          steps.push({
                            label: stage.label,
                            role: payment[stage.key]?.name || stage.label,
                            status: 'approved',
                            date: payment[stage.dateKey] || payment?.createdAt,
                          });
                        }
                      }

                      const rejectionStageIndex = Math.min(2, approvalStages.length - 1);
                      const rejectionStage = approvalStages[rejectionStageIndex];
                      steps.push({
                        label: rejectionStage.label,
                        role: payment?.rejectedBy?.name || rejectionStage.label,
                        status: 'rejected',
                        date: payment.rejectedAt,
                      });
                    }
                  }
                  else if (payment?.status === 'Approved') {
                    steps.push({
                      label: 'Raised By',
                      role: getRaisedByRole(),
                      status: 'approved',
                      date: payment.raisedAt || payment?.createdAt,
                    });

                    for (const stage of approvalStages) {
                      if (payment[stage.key] === null) continue;

                      if (payment.finalApprover || payment[stage.key]) {
                        steps.push({
                          label: stage.label,
                          role: payment[stage.key]?.name || stage.label,
                          status: 'approved',
                          date: payment[stage.dateKey] || payment.approvedAt || payment?.createdAt,
                        });
                      } else {
                        // Show as default approved if finalApprover exists
                        steps.push({
                          label: stage.label,
                          role: stage.label,
                          status: 'approved',
                          date: payment?.createdAt,
                        });
                      }
                    }
                  }
                  return steps;
                };
                              const approvalSteps = generateApprovalTrack(item);
              
                              return (
                                <Box
                                  key={item._id}
                                  sx={{
                                    border: '1px solid #ccc',
                                    borderRadius: '8px',
                                    p: 2,
                                    mt: 2,
                                    backgroundColor: item?.status === 'Approved' ? '#e8f5e9' : item?.status === 'Rejected' ? '#ffebee' : '#fffde7',
                                  }}
                                >
                                  <Typography variant="subtitle1" fontWeight="bold">
                                    <strong>
                                      {item?.status === 'Approved'
                                        ? 'Approved'
                                        : item?.status === 'Rejected'
                                          ? 'Rejected'
                                          : 'Raised'}
                                    </strong>
                                  </Typography>
              
                                  <Typography><strong>Amount:</strong> ₹{item.amount}</Typography>
                                  <Typography><strong>Project Type:</strong> {item.paymentType || 'Other'}</Typography>
                                  
                                  {item?.status === 'Approved' && (
                                    <Typography><strong>Approved At:</strong> {item?.approvedAt || item?.finalApprovalDate
                                      ? moment(item.approvedAt || item.finalApprovalDate).format("DD/MM/YYYY hh:mm A")
                                      : "--"}
                                    </Typography>
                                  )}
                                  {item?.status === 'Rejected' && (
                                    <>
                                      <Typography><strong>Rejected At:</strong> {item?.rejectedAt
                                        ? moment(item.rejectedAt).format("DD/MM/YYYY hh:mm A")
                                        : "--"}
                                      </Typography>
                                      <Typography variant="body2" sx={{ mt: 1 }}>
                                        <strong>Rejection Reason:</strong> {item.rejectReason || 'N/A'}
                                      </Typography>
                                    </>
                                  )}
                                  {item?.status === 'Raised' && (
                                    <Typography><strong>Raised At:</strong> {item?.createdAt ? moment(item.createdAt).format("DD/MM/YYYY hh:mm A") : "--"}</Typography>
                                  )}
              
                                  {/* Approval Track Stepper - Horizontal */}
                                  <Box sx={{ mt: 3 }}>
                                    <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 2 }}>
                                      Approval Track:
                                    </Typography>
              
                                    <Stepper orientation="horizontal" sx={{ mt: 1, flexWrap: 'wrap' }}>
                                      {approvalSteps.map((step, stepIndex) => (
                                        <Step key={stepIndex} active={true} completed={step.status === 'approved'}>
                                          <StepLabel
                                            StepIconComponent={() => (
                                              <Box
                                                sx={{
                                                  width: 32,
                                                  height: 32,
                                                  borderRadius: '50%',
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                  justifyContent: 'center',
                                                  backgroundColor:
                                                    step?.status === 'approved' ? '#4caf50' :
                                                      step?.status === 'rejected' ? '#f44336' : '#ff9800',
                                                  color: 'white',
                                                  fontSize: '14px',
                                                  fontWeight: 'bold'
                                                }}
                                              >
                                                {step.status === 'approved' ? '✓' :
                                                  step?.status === 'rejected' ? '✕' : '⧖'}
                                              </Box>
                                            )}
                                            sx={{
                                              '& .MuiStepLabel-label': {
                                                color: step?.status === 'rejected' ? 'error.main' :
                                                  step?.status === 'approved' ? 'success.main' : 'warning.main',
                                                fontWeight: 'medium',
                                                fontSize: '0.875rem'
                                              },
                                              flexDirection: 'column',
                                              alignItems: 'center'
                                            }}
                                          >
                                            <Box sx={{
                                              display: 'flex',
                                              flexDirection: 'column',
                                              alignItems: 'center',
                                              gap: 0.5,
                                              mt: 1,
                                              minWidth: '120px',
                                              textAlign: 'center'
                                            }}>
                                              <Typography variant="body2" fontWeight="medium" sx={{ lineHeight: 1.2 }}>
                                                {step?.label}
                                              </Typography>
                                              <Chip
                                                label={step.role}
                                                size="small"
                                                variant="outlined"
                                                sx={{
                                                  fontSize: '0.7rem',
                                                  height: '22px',
                                                  backgroundColor:
                                                    step?.status === 'approved' ? '#e8f5e9' :
                                                      step?.status === 'rejected' ? '#ffebee' : '#fff3e0',
                                                  color: step?.status === 'rejected' ? 'error.main' :
                                                    step?.status === 'approved' ? 'success.main' : 'warning.main'
                                                }}
                                              />
                                              <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
                                                {step?.date ? new Date(step?.date).toLocaleDateString() : 'N/A'}
                                              </Typography>
                                              {step.status === 'rejected' && (
                                                <Typography variant="caption" color="error.main" sx={{ fontSize: '0.7rem', textAlign: 'center' }}>
                                                  Rejected
                                                </Typography>
                                              )}
                                            </Box>
                                          </StepLabel>
                                        </Step>
                                      ))}
                                    </Stepper>
                                  </Box>
              
                                  {item?.remarks && (
                                    <Typography variant="body2" sx={{ mt: 1 }}>
                                      <strong>Remarks:</strong> {item?.remarks}
                                    </Typography>
                                  )}
                                </Box>
                              );
                            })}
            </>
          )}
        </Box>
      </Modal>
    </div>
  );
};

export default connect(null, { setLoading, setSnackInfo })(OperationStageSo);